import React from 'react'
import { Col, Container, Nav, NavDropdown, NavLink, Navbar, Row } from 'react-bootstrap'
import Facebook from '../resources/Facebook.png';
import Google from '../resources/Google.png';
import Twitter from '../resources/Twitter.png';
import Instagram from '../resources/Instagram.png';
export default function FootBar() {
    return (
        <Container className='mb-0' style={{ color: '#FFFF', backgroundColor: '#AA4A44', maxWidth: '100%' }}>
            <Row style={{ color: 'black', backgroundColor: '#eceff7' }}>
                <Col lg={2}></Col>
                <Col lg={8} style={{ textAlign: 'center', margin: '1%' }}>
                    <span>Do you like our free editing service? Please help us by linking to our social media pages:
                    </span>
                    <Col lg={12} style={{ marginTop: '1%' }}>
                        <a href='https://www.facebook.com/people/EnglishEdit-AI/61555766825781/' target='_blank'><img src={Facebook} alt="logo" style={{ width: 50 + 'px', margin: '6px' }} /></a>
                        <img src={Twitter} alt="logo" style={{ width: 50 + 'px', margin: '6px' }} />
                        <img src={Google} alt="logo" style={{ width: 54 + 'px', margin: '6px' }} />
                        <a href='https://www.instagram.com/englisheditai/' target='_blank'><img src={Instagram} alt="logo" style={{ width: 50 + 'px', margin: '6px' }} /></a>

                    </Col>
                </Col>

            </Row>
            <Row>
                <Col lg={3}></Col>
                <Col lg={9}>
                    <Navbar style={{ height: '4.5em' }} expand="lg" className="bg-body-primary mt-3">
                        <Container>
                            <Navbar.Toggle aria-controls="basic-navbar-nav" />
                            <Navbar.Collapse id="basic-navbar-nav" className="justify-content-start justify-content-lg-start">
                                <Nav className="me-auto">
                                    <Nav.Link style={{ color: '#FFF' }} as={NavLink} href="/">Home</Nav.Link>
                                    <Nav.Link style={{ color: '#FFF' }} className='ms-3' as={NavLink} href="/howitworks">How it works</Nav.Link>
                                    <Nav.Link style={{ color: '#FFF' }} className='ms-3' as={NavLink} href="/aiediting">AI Editing Technology</Nav.Link>
                                    <Nav.Link style={{ color: '#FFF' }} className='ms-3' as={NavLink} href="/aboutus">About Us</Nav.Link>
                                    <Nav.Link style={{ color: '#FFF' }} className='ms-3' as={NavLink} href="#">Give us Feedback</Nav.Link>
                                    <Nav.Link style={{ color: '#FFF' }} className='ms-3' as={NavLink} href="/contactus">Contact us</Nav.Link>
                                </Nav>

                            </Navbar.Collapse>
                        </Container>
                    </Navbar>
                </Col>
                <Col></Col>
            </Row>
            <Row>
                <Col lg={2}></Col>
                <Col lg={8} style={{ textAlign: 'center' }}>
                    <span>22619 SE 64th Place, Suite 220, Issaquah, WA 98027</span>
                </Col>

            </Row>
            <Row>
                <Col lg={2}></Col>
                <Col lg={8} style={{ textAlign: 'center' }}>
                    <span>EnglishEdit.AI is a division of <a style={{ color: '#9bc97f' }} href="http://grammarlabs.com">Grammar Labs</a> </span>
                </Col>

            </Row>
            <Row>
                <Col lg={2}></Col>
                <Col className='mb-4' lg={8} style={{ textAlign: 'center' }}>
                    <span style={{ fontSize: '0.8em' }}>Grammar Labs is dedicated to creating innovative services and products for the world’s 600 million+ non-native English speakers.</span>
                </Col>
            </Row>
        </Container>

    )
}